import React, { useState } from 'react';
import { Button, Input } from 'antd';
import { getTranslated, getAccess } from 'utils';
import { StyledRow, StyledInput } from './Searchs.styled';

const Searchs = ({ locale, admin, userPermissions, history }) => {
    const [search, setSearch] = useState('');
    const [order, setOrder] = useState('');
    const [orderItem, setOrderItem] = useState('');

    function handleSearchOrder() {
        history.push(`/crm/orders/view/${order}`);
    }

    function handleSearchOrderItem() {
        history.push(`/order-item/${orderItem}`);
    }

    function handleGlobalSearch() {
        history.push(`/search/?v=${search.trim()}`);
    }

    const userRoles = getAccess(userPermissions, 'orders');

    return (
        <StyledRow align="middle" gutter={24}>
            {
                admin !== 'mercuryflooring' && (
                    <Input.Group compact>
                        <StyledInput
                            placeholder={getTranslated('topbar.globalSearch', locale)}
                            onChange={e => setSearch(e.target.value)}
                            value={search}
                            onPressEnter={handleGlobalSearch}
                        />

                        <Button type="primary" htmlType="button" onClick={handleGlobalSearch} className="gx-mb-0">
                            <i className="la la la-globe la-lg" />
                        </Button>
                    </Input.Group>
                )
            }

            {
                userRoles.includes('read') && (
                    <Input.Group compact>
                        <StyledInput
                            placeholder={getTranslated('topbar.findOrder', locale)}
                            onChange={e => setOrder(e.target.value)}
                            value={order}
                            onPressEnter={handleSearchOrder}
                        />

                        <Button type="primary" htmlType="button" onClick={handleSearchOrder} className="gx-mb-0">
                            <i className="la la-shopping-cart la-lg" />
                        </Button>
                    </Input.Group>
                )
            }

            {
                userRoles.includes('read') && (
                    <Input.Group compact>
                        <StyledInput
                            placeholder={getTranslated('topbar.findOrderItem', locale)}
                            onChange={e => setOrderItem(e.target.value)}
                            value={orderItem}
                            onPressEnter={handleSearchOrderItem}
                        />

                        <Button type="primary" htmlType="button" onClick={handleSearchOrderItem} className="gx-mb-0">
                            <i className="la la-shopping-cart la-lg" />
                        </Button>
                    </Input.Group>
                )
            }
        </StyledRow>
    );
};

export default Searchs;
